import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {useState} from 'react';
import DotsLoading from '../../../../../components/dotsLoading';
import MainFooter from '../../../../../components/mazraeKit/footers/footerMain';
import CustomHeader from '../../../../../components/mazraeKit/headers/homeHeader';
import Stepper from '../../../../../components/mazraeKit/stepper';
import PrimaryCardAR from '../../../../../module/newShop/advertisementRegisteration/primaryCardAR';
import useGetInputLists from '../../../../../services/hookService/getInputLists/useGetInputLists';
import useGetStoreTypeList from '../../../../../services/hookService/getStoreTypeList/useGetStoreTypeList';
import {RootState} from '../../../../../store/redux';
import {
  addRegisterStoreFormData,
  resetRegisterStore,
} from '../../../../../store/redux/registerStore';
import {clearAddress} from '../../../../../store/redux/searchingLocation';
import {getStoreName, stepperData} from '../../contants';
import RegisterStoreLabBottomSheet from '../../elements/bottomSheetLists/registerStoreLabBottomSheet';

const RegisterStoreLab = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [labBottomSheet, setLabBottomSheet] = useState<boolean>(false);
  const state = useSelector((state: RootState) => state.registerStore);

  const {data: inputlists} = useGetInputLists({
    input_group__guid: state.selectedInput?.guid,
  });

  const {data, isLoading} = useGetStoreTypeList({});

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-full">
        <DotsLoading />
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full">
      <CustomHeader
        title={'ثبت فروشگاه'}
        preIcon="icon-nameArrow---Right"
        postComponent={() => (
          <i className={`icon-nameProfile text-[25px] text-gray-700`} />
        )}
        isActiveRightIcon={true}
      />
      <div className="flex flex-col w-full h-full px-3 py-3 overflow-y-auto">
        <Stepper currentStep={1} steps={stepperData} />
        <div className="flex flex-col">
          <span className="mt-12 mb-4 text-md">چه نوع فروشگاهی دارید؟</span>
          <div className="grid grid-cols-2 gap-2">
            {data?.map((item, index) => (
              <PrimaryCardAR
                key={item.id ?? index}
                title={item.title}
                desc={item.title_description}
                active={false}
                image={`https://s3.ir-thr-at1.arvanstorage.ir/my-store/${item.icon}.jpg`}
                onClick={() => {
                  dispatch(clearAddress());
                  dispatch(resetRegisterStore({}));
                  dispatch(
                    addRegisterStoreFormData({
                      selectedInput: {
                        id: item.id,
                        code: item.code,
                        guid: item.input_groups[0].guid,
                      },
                    }),
                  );
                  if (item.id !== 2) {
                    navigate(`/register-store/${getStoreName(item.code)}`);
                  } else {
                    setLabBottomSheet && setLabBottomSheet(true);
                  }
                }}
              />
            ))}
          </div>
        </div>
      </div>
      <RegisterStoreLabBottomSheet
        {...{
          labBottomSheet,
          setLabBottomSheet,
          inputlists,
        }}
      />
      <MainFooter />
    </div>
  );
};

export default RegisterStoreLab;
